<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Document No.
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="docNoItems"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>{{ row.item.branch }}</td>
                  <td>{{ row.item.fund }}</td>
                  <td>{{ row.item.docNo }}</td>
                  <td>{{ row.item.tranType1 }}</td>
                  <td>{{ row.item.curr }}</td>
                  <td>{{ formatDisplayNumber(row.item.paytAmt, 2) }}</td>
                  <td style="text-align: center">
                    <v-btn text icon color="primary" type="submit" @click.prevent="assignDocNo(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import claimReleaseMixin from '@/mixins/claim/claimReleaseMixin'
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      headers: [
        { text: 'Branch', value: 'branch', align: 'left' },
        { text: 'Fund', value: 'fund', align: 'left' },
        { text: 'Document No.', value: 'docNo', align: 'left' },
        { text: 'Transaction Type', value: 'tranType1', align: 'left' },
        { text: 'Currency', value: 'curr', align: 'left' },
        { text: 'Amount', value: 'amount', align: 'left' },
        { text: 'Action', value: 'action', align: 'left' }
      ],
      docNoItems: []
    }
  },
  created() {},
  mounted() {
    this.doFetchUnRelClmDoc(this.branch, this.tranType1)
  },
  methods: {
    assignDocNo(data) {
      this.$emit('assign-docNo', data)
      this.$emit('close')
    },
    doClose() {
      this.$emit('close')
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    }
  },
  watch: {
    branch: function () {
      this.doFetchUnRelClmDoc(this.branch, this.tranType1)
    },
    tranType1: function () {
      this.doFetchUnRelClmDoc(this.branch, this.tranType1)
    },
    fund: function () {
      this.doFetchUnRelClmDoc(this.branch, this.tranType1)
    },
    refresh: function () {
      this.doFetchUnRelClmDoc(this.branch, this.tranType1)
    }
  },
  mixins: [TableConst.default, MessageMixin, claimReleaseMixin],
  props: ['branch', 'fund', 'tranType1']
}
</script>

<style>
</style>
